"use es6";

import { FromEventObservable } from './FromEventObservable';
export const fromEvent = FromEventObservable.create;